import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=adbec6a6&scoped=true"
import script from "./ArticlesList.vue?vue&type=script&lang=js"
export * from "./ArticlesList.vue?vue&type=script&lang=js"
import style0 from "./ArticlesList.vue?vue&type=style&index=0&id=adbec6a6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adbec6a6",
  null
  
)

export default component.exports